import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import { geometryTypes as t } from "../../geometry.js";
import r from "../../Graphic.js";
import { JSONMap as o } from "../../core/jsonMap.js";
import { JSONSupport as s } from "../../core/JSONSupport.js";
import { isSome as n, unwrap as i } from "../../core/maybe.js";
import { property as p } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { reader as a } from "../../core/accessorSupport/decorators/reader.js";
import { subclass as l } from "../../core/accessorSupport/decorators/subclass.js";
import { writer as y } from "../../core/accessorSupport/decorators/writer.js";
import m from "../../geometry/SpatialReference.js";
import { fromJSON as u, isPolygon as c } from "../../geometry/support/jsonUtils.js";
import f from "../../layers/support/Field.js";
var h = new o({
  esriGeometryPoint: "point",
  esriGeometryMultipoint: "multipoint",
  esriGeometryPolyline: "polyline",
  esriGeometryPolygon: "polygon",
  esriGeometryEnvelope: "extent",
  mesh: "mesh",
  "": null
});

var d = /*#__PURE__*/function (_s) {
  _inherits(d, _s);

  var _super = _createSuper(d);

  function d(e) {
    var _this;

    _classCallCheck(this, d);

    _this = _super.call(this, e), _this.displayFieldName = null, _this.exceededTransferLimit = !1, _this.features = [], _this.fields = null, _this.geometryType = null, _this.hasM = !1, _this.hasZ = !1, _this.queryGeometry = null, _this.spatialReference = null;
    return _this;
  }

  _createClass(d, [{
    key: "readFeatures",
    value: function readFeatures(e, t) {
      var o = m.fromJSON(t.spatialReference),
          s = [];

      for (var _i = 0; _i < e.length; _i++) {
        var _t = e[_i],
            _p = r.fromJSON(_t),
            _a = _t.geometry && _t.geometry.spatialReference;

        n(_p.geometry) && !_a && (_p.geometry.spatialReference = o), s.push(_p);
      }

      return s;
    }
  }, {
    key: "writeGeometryType",
    value: function writeGeometryType(e, t, r, o) {
      if (e) return void h.write(e, t, r, o);
      var s = this.features;

      if (s) {
        var _iterator = _createForOfIteratorHelper(s),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _i2 = _step.value;
            if (_i2 && n(_i2.geometry)) return void h.write(_i2.geometry.type, t, r, o);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }, {
    key: "readQueryGeometry",
    value: function readQueryGeometry(e, t) {
      if (!e) return null;
      var r = !!e.spatialReference,
          o = u(e);
      return !r && t.spatialReference && (o.spatialReference = m.fromJSON(t.spatialReference)), o;
    }
  }, {
    key: "writeSpatialReference",
    value: function writeSpatialReference(e, t) {
      if (e) return void (t.spatialReference = e.toJSON());
      var r = this.features;

      if (r) {
        var _iterator2 = _createForOfIteratorHelper(r),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _o = _step2.value;
            if (_o && n(_o.geometry) && _o.geometry.spatialReference) return void (t.spatialReference = _o.geometry.spatialReference.toJSON());
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON(e) {
      var t = this.write();
      if (t.features && Array.isArray(e) && e.length > 0) for (var _r = 0; _r < t.features.length; _r++) {
        var _o2 = t.features[_r];

        if (_o2.geometry) {
          var _t2 = e && e[_r];

          _o2.geometry = _t2 && _t2.toJSON() || _o2.geometry;
        }
      }
      return t;
    }
  }, {
    key: "quantize",
    value: function quantize(e) {
      var _e$scale = _slicedToArray(e.scale, 2),
          t = _e$scale[0],
          r = _e$scale[1],
          _e$translate = _slicedToArray(e.translate, 2),
          o = _e$translate[0],
          s = _e$translate[1],
          n = function n(e) {
        return Math.round((e - o) / t);
      },
          p = function p(e) {
        return Math.round((s - e) / r);
      },
          a = this.features,
          l = this._getQuantizationFunction(this.geometryType, n, p);

      for (var _y = 0, _m = a.length; _y < _m; _y++) {
        l(i(a[_y].geometry)) || (a.splice(_y, 1), _y--, _m--);
      }

      return this.transform = e, this;
    }
  }, {
    key: "unquantize",
    value: function unquantize() {
      var e = this.geometryType,
          t = this.features,
          r = this.transform;
      if (!r) return this;

      var _r$translate = _slicedToArray(r.translate, 2),
          o = _r$translate[0],
          s = _r$translate[1],
          _r$scale = _slicedToArray(r.scale, 2),
          i = _r$scale[0],
          p = _r$scale[1],
          a = function a(e) {
        return e * i + o;
      },
          l = function l(e) {
        return s - e * p;
      },
          y = this._getHydrationFunction(e, a, l);

      var _iterator3 = _createForOfIteratorHelper(t),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _m2 = _step3.value.geometry;
          n(_m2) && y(_m2);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return this.transform = null, this;
    }
  }, {
    key: "_quantizePoints",
    value: function _quantizePoints(e, t, r) {
      var o, s;
      var n = [];

      for (var _i3 = 0, _p2 = e.length; _i3 < _p2; _i3++) {
        var _p3 = e[_i3];

        if (_i3 > 0) {
          var _e = t(_p3[0]),
              _i4 = r(_p3[1]);

          _e === o && _i4 === s || (n.push([_e - o, _i4 - s]), o = _e, s = _i4);
        } else o = t(_p3[0]), s = r(_p3[1]), n.push([o, s]);
      }

      return n.length > 0 ? n : null;
    }
  }, {
    key: "_getQuantizationFunction",
    value: function _getQuantizationFunction(e, t, r) {
      var _this2 = this;

      return "point" === e ? function (e) {
        return e.x = t(e.x), e.y = r(e.y), e;
      } : "polyline" === e || "polygon" === e ? function (e) {
        var o = c(e) ? e.rings : e.paths,
            s = [];

        for (var _n = 0, _i5 = o.length; _n < _i5; _n++) {
          var _e2 = o[_n],
              _i6 = _this2._quantizePoints(_e2, t, r);

          _i6 && s.push(_i6);
        }

        return s.length > 0 ? (c(e) ? e.rings = s : e.paths = s, e) : null;
      } : "multipoint" === e ? function (e) {
        var o = _this2._quantizePoints(e.points, t, r);

        return o.length > 0 ? (e.points = o, e) : null;
      } : "extent" === e ? function (e) {
        return e;
      } : null;
    }
  }, {
    key: "_getHydrationFunction",
    value: function _getHydrationFunction(e, t, r) {
      return "point" === e ? function (e) {
        e.x = t(e.x), e.y = r(e.y);
      } : "polyline" === e || "polygon" === e ? function (e) {
        var o = c(e) ? e.rings : e.paths;
        var s, n;

        for (var _i7 = 0, _p4 = o.length; _i7 < _p4; _i7++) {
          var _e3 = o[_i7];

          for (var _o3 = 0, _i8 = _e3.length; _o3 < _i8; _o3++) {
            var _i9 = _e3[_o3];
            _o3 > 0 ? (s += _i9[0], n += _i9[1]) : (s = _i9[0], n = _i9[1]), _i9[0] = t(s), _i9[1] = r(n);
          }
        }
      } : "extent" === e ? function (e) {
        e.xmin = t(e.xmin), e.ymin = r(e.ymin), e.xmax = t(e.xmax), e.ymax = r(e.ymax);
      } : "multipoint" === e ? function (e) {
        var o = e.points;
        var s, n;

        for (var _i10 = 0, _p5 = o.length; _i10 < _p5; _i10++) {
          var _e4 = o[_i10];
          _i10 > 0 ? (s += _e4[0], n += _e4[1]) : (s = _e4[0], n = _e4[1]), _e4[0] = t(s), _e4[1] = r(n);
        }
      } : void 0;
    }
  }]);

  return d;
}(s);

e([p({
  type: String,
  json: {
    write: !0
  }
})], d.prototype, "displayFieldName", void 0), e([p({
  type: Boolean,
  json: {
    write: {
      overridePolicy: function overridePolicy(e) {
        return {
          enabled: e
        };
      }
    }
  }
})], d.prototype, "exceededTransferLimit", void 0), e([p({
  type: [r],
  json: {
    write: !0
  }
})], d.prototype, "features", void 0), e([a("features")], d.prototype, "readFeatures", null), e([p({
  type: [f],
  json: {
    write: !0
  }
})], d.prototype, "fields", void 0), e([p({
  type: ["point", "multipoint", "polyline", "polygon", "extent", "mesh"],
  json: {
    read: {
      reader: h.read
    }
  }
})], d.prototype, "geometryType", void 0), e([y("geometryType")], d.prototype, "writeGeometryType", null), e([p({
  type: Boolean,
  json: {
    write: {
      overridePolicy: function overridePolicy(e) {
        return {
          enabled: e
        };
      }
    }
  }
})], d.prototype, "hasM", void 0), e([p({
  type: Boolean,
  json: {
    write: {
      overridePolicy: function overridePolicy(e) {
        return {
          enabled: e
        };
      }
    }
  }
})], d.prototype, "hasZ", void 0), e([p({
  types: t,
  json: {
    write: !0
  }
})], d.prototype, "queryGeometry", void 0), e([a("queryGeometry")], d.prototype, "readQueryGeometry", null), e([p({
  type: m,
  json: {
    write: !0
  }
})], d.prototype, "spatialReference", void 0), e([y("spatialReference")], d.prototype, "writeSpatialReference", null), e([p({
  json: {
    write: !0
  }
})], d.prototype, "transform", void 0), d = e([l("esri.rest.support.FeatureSet")], d), d.prototype.toJSON.isDefaultToJSON = !0;
var g = d;
export { g as default };